import type { HTMLAttributes } from "react";

import "./tones.css";
import "./badge.css";
import { badgeClass, type BadgeSize, type BadgeTone, type BadgeVariant } from "./badge-class";

export type { BadgeSize, BadgeTone, BadgeVariant } from "./badge-class";

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: BadgeVariant;
  tone?: BadgeTone;
  size?: BadgeSize;
}

/**
 * Small status/label pill. Token-driven via the variant×tone×size grammar; non-interactive
 * (no focus ring). Defaults to a neutral soft pill.
 */
export function Badge({
  variant = "soft",
  tone = "neutral",
  size = "md",
  className,
  ...rest
}: BadgeProps) {
  return <span className={badgeClass(variant, tone, size, className)} {...rest} />;
}
